import React, { useState } from "react";
import {
  Grid,
  Tooltip,
  IconButton,
  Box,
  Select,
  MenuItem,
  Divider,
  Pagination,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {
  Close as CloseIcon,
  PermMedia as PermMediaIcon
} from "@mui/icons-material";
import moment from "moment";
import { SkeletonLoadingTable, VisibleContent, ZoomableImage } from "../../../components";
import {getUrlForStaticApi} from "../../../utils/urlStaticFiles";
import clsx from "clsx";

const compactMedia = "@media (max-width: 1399.95px)";

const TableCustom = ({
  items = [],
  filter,
  totalPages,
  totalCount,
  isLoading,
  onSearch,
  onChangeFilter,
  onOpenDetails = () => {},
}) => {
  const classes = useStyles();
  const [detectionsModal, setDetectionsModal] = useState({ open: false, urls: [] });

  const handleChangePage = (e, page) => {
    onChangeFilter(
      {
        ...filter,
        page,
      },
      true
    );
  };

  const handleChangeLimit = (e) => {
    onChangeFilter({ ...filter, page: 1, limit: e.target.value }, true);
  };

  return (
    <>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Без госномера</TableCell>
            <TableCell>С госномером</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell sx={{ pt: 0, pb: 0, lineHeight: "1.1!important" }}>Распознанный<br/>госномер</TableCell>
            <TableCell>Серийный номер СВК</TableCell>
            <TableCell sx={{ pt: 0, pb: 0, lineHeight: "1.1!important" }}>Дата и время<br/>фиксации СВК</TableCell>
            <TableCell sx={{ pt: 0, pb: 0, lineHeight: "1.1!important" }}>Серийный номер<br/>комплекса</TableCell>
            <TableCell sx={{ pt: 0, pb: 0, lineHeight: "1.1!important" }}>Дата и время<br/>фиксации комплекса</TableCell>
            <TableCell/>
          </TableRow>
        </TableHead>
        <TableBody>
          <VisibleContent visible={!isLoading}>
            {items.map((item, index) => (
              <RowItem
                key={`hidden-grz-row-${item?.id || index}`}
                item={item}
                onOpenDetails={onOpenDetails}
                onOpenDetections={(urls) => setDetectionsModal({ open: true, urls: urls || [] })}
              />
            ))}
          </VisibleContent>
          <VisibleContent visible={isLoading}>
            <SkeletonLoadingTable countRows={10} countColumns={9} />
          </VisibleContent>
        </TableBody>
      </Table>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 2 }}>
        <span style={{ fontSize: 14, color: "#71717A" }}>Найдено {totalCount.toLocaleString('ru-RU')} записей</span>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: 14, color: "#71717A" }}>
            <span>Выводить по</span>
            <Select value={filter.limit} onChange={handleChangeLimit} size="small" sx={{ minWidth: 70, height: 32, fontSize: 14 }}>
              <MenuItem value={15}>15</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </Box>
          {totalPages > 1 && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: 14, color: "#71717A" }}>
              <span>Страница {filter.page} из {totalPages}</span>
              <Pagination count={totalPages} page={filter.page} onChange={handleChangePage} size="small" />
            </Box>
          )}
        </Box>
      </Box>

      <DetectionsModal
        open={detectionsModal.open}
        urls={detectionsModal.urls}
        onClose={() => setDetectionsModal({ open: false, urls: [] })}
      />
    </>
  );
};
const RowItem = ({ item, onOpenDetections, onOpenDetails }) => {
  const classes = useStyles()
  const isRecognized = Boolean(item.recognized);
  const getDateTime = (datetime) => {
    if (!datetime || datetime === '0001-01-01T00:00:00Z') return "—";
    const parsed = moment.parseZone(datetime);
    if (!parsed.isValid()) return datetime;
    return parsed.format("DD.MM.YYYY HH:mm:ss");
  }

  const detections = item?.detections_urls || [];
  const detectionsCount = detections.length;
  const handleRowClick = () => {
    if (typeof onOpenDetails === "function") {
      onOpenDetails(item);
    }
  };

  return (
    <TableRow
      hover
      onClick={handleRowClick}
      sx={{ cursor: typeof onOpenDetails === "function" ? "pointer" : "default" }}
    >
      <TableCell>
        <RowItemImage url={getUrlForStaticApi(item.task_url)}/>
      </TableCell>
      <TableCell>
        <RowItemImage url={getUrlForStaticApi(item.recognized_url)}/>
      </TableCell>
      <TableCell>
        <Chip
          label={isRecognized ? 'Распознано' : 'Не распознано'}
          size="small"
          sx={{
            fontWeight: 600, fontSize: 12,
            backgroundColor: isRecognized ? '#E4FBF1' : '#FFEAE7',
            color: isRecognized ? '#1CA673' : '#E85949',
          }}
        />
      </TableCell>
      <TableCell>{item?.sensor?.license_plate || "—"}</TableCell>
      <TableCell>—</TableCell>
      <TableCell>{getDateTime(item?.apvgk?.datetime)}</TableCell>
      <TableCell>{item?.sensor?.complex_serial || '—'}</TableCell>
      <TableCell>{getDateTime(item?.sensor?.datetime)}</TableCell>
      <TableCell align="right">
        <Tooltip title={`Все фото нейросети (${ detectionsCount })`}>
          <IconButton
            disabled={!detectionsCount}
            onClick={(e) => {
              e.stopPropagation();
              onOpenDetections(detections);
            }}
          >
            <PermMediaIcon/>
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};
const RowItemImage = ({ url }) => {
  const classes = useStyles();

  const handleClick = (event) => {
    // Не открываем детализацию строки при работе с изображением
    event.stopPropagation();
  };

  return (
    <div className={classes.rowItemImage} onClick={handleClick}>
      {Boolean(url) && (<ZoomableImage src={url}/>)}
      {Boolean(!url) && (<div className="no-result">Не распознано</div>)}
    </div>
  )
}
const DetectionsModal = ({ open, urls = [], onClose }) => {
  const classes = useStyles();
  const hasUrls = urls.length > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          Фотоматериалы нейросети
          <Chip label={urls.length} size="small" sx={{ backgroundColor: "#E0E7FF", color: "#432DD7", fontWeight: 600, fontSize: 12 }} />
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2, p: 1.5, borderRadius: "8px", backgroundColor: "#FAFAFA", border: "1px solid #E4E4E7", fontSize: 14, color: "#27272A" }}>
          Нейронная сеть подобрала следующие варианты фиксаций транспортных средств с ГРЗ:
        </Box>
        {hasUrls && (
          <Grid container spacing={2}>
            {urls.map((item, idx) => (
              <Grid item size={3} key={idx}>
                <div className={clsx(classes.detectionImage, item.is_approved && '--selected')}>
                  <ZoomableImage src={getUrlForStaticApi(item.url)} />
                </div>
              </Grid>
            ))}
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles((theme) => ({
  table: {
    [compactMedia]: {
      "& .MuiTableCell-root": {
        paddingLeft: 8,
        paddingRight: 8,
        fontSize: 13,
      },
      "& .MuiTableCell-head": {
        fontSize: 12,
        lineHeight: "16px",
        whiteSpace: "normal",
      },
      "& .MuiChip-root": {
        height: 22,
        fontSize: 11,
      },
      "& .MuiIconButton-root": {
        padding: 4,
      },
    },
  },
  rowItemImage: {
    width: 150,
    height: 70,
    borderRadius: 4,
    overflow: "hidden",
    position: "relative",
    background: "#E0E2E8",
    [compactMedia]: {
      width: 96,
      height: 52,
      "& .no-result": {
        fontSize: 12,
      },
    },

    "& > div": {
      width: "100%",
      height: "100%",
      borderRadius: 0,
      backgroundColor: "transparent",
    },
    "& img": {
      objectFit: "contain",
    },
    "& .no-result": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      fontSize: 16,
      fontWeight: '400',
    }
  },

  detectionImage: {
    width: "100%",
    height: 160,
    overflow: "hidden",
    borderRadius: 8,
    position: "relative",
    background: "#FAFAFA",
    border: "1px solid #E4E4E7",

    "& > div": {
      height: "100%",
      backgroundColor: "transparent",
    },
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },

    "&.--selected": {
      borderColor: "#1CA673",
      backgroundColor: "#F0FDF4",

      "&:after": {
        content: "'Выбрано'",
        position: "absolute",
        top: 8, right: 8,
        borderRadius: 4,
        padding: "2px 8px",
        backgroundColor: "#1CA673",
        fontSize: 11,
        color: "white",
        fontWeight: 600,
        lineHeight: "16px",
      }
    }
  },

  status_unused: {
    "&.on": {
      background: "#E4FBF1",
      color: "#1CA673",
      fontWeight: "600",
    },
    "&.off": {
      background: "#FFEAE7",
      color: "#E85949",
      fontWeight: "600",
    },
  }
}))

export default TableCustom
